import * as THREE from "three";

function createScatterBuffer(length: number) {
  const buf = new THREE.Float32BufferAttribute(new Float32Array(length * 3), 3);

  for (let i = 0; i < buf.count; i++) {
    const x = (Math.random() - 0.5) * 1000;
    const y = 0 + (Math.random() - 0.5) * 6400;
    const z = Math.random() * 2000;
    buf.setXYZ(i, x, y, z);
  }

  return buf;
}

function createRandomSeedBuffer(length: number) {
  const array = Float32Array.from({ length }, () => Math.random() * 2 - 1);

  return new THREE.Float32BufferAttribute(array, 1);
}

export class AvatarGeometry extends THREE.BufferGeometry {
  constructor(pointCount: number) {
    super();

    const scatter = createScatterBuffer(pointCount);
    const random = createRandomSeedBuffer(pointCount);

    // Copy of scatter otherwise THREE js freaks out :)
    this.setAttribute("position", scatter);
    this.setAttribute("scatter", scatter);
    this.setAttribute("deviation", random);
  }

  setPointPositions(
    attribute: "front" | "back" | "heart",
    buffer: THREE.Float32BufferAttribute
  ) {
    this.setAttribute(attribute, buffer);
  }
}
